// JsFromRoutes CacheKey 7a57ea128e06a4151ce0eec8a6e3a771
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  fetchUsersAndGroups: definePathHelper('get', '/organisations/fetch_users_and_groups'),
}
